/**
 * Which consent treatment an org's IDX sign-up surfaces render.
 *
 * - `passive` no checkbox; the form carries "by submitting this form" consent.
 * - `bundled` one checkbox covering call, email and text; blocks submission.
 * - `split`   two optional checkboxes (text, then calls-and-email); neither blocks.
 */
export type ConsentStyle = "passive" | "bundled" | "split";

/**
 * Resolve the consent treatment for an org from its `idx_consent_style` column.
 *
 * Every org is backfilled, so the column is the only source. An org arriving
 * without one falls back to the bundled checkbox: that is the treatment that
 * asks for consent and blocks on it, so a missing value can never silently
 * drop an opt-in an org is supposed to collect.
 */
export const resolveConsentStyle = (
  configuredStyle: ConsentStyle | null | undefined
): ConsentStyle => configuredStyle ?? "bundled";

/** FUB capture scope uses the existing two-group form without changing other orgs. */
export const resolveIdxConsentStyle = (
  configuredStyle: ConsentStyle | null | undefined,
  captureEnabled: boolean
): ConsentStyle => (captureEnabled ? "split" : resolveConsentStyle(configuredStyle));
